export const OFFSET = 50;
export const PAGE = 1;
export const LIMIT_ITEMS_SELECT = 1000;
export const DAYS_PER_PARGE = 7;

export const ROOT_HOUSEKEEPING_LIMIT = 20;

export const PAGINATION_OPTIONS = [5, 10, 15, 20, 25, 50, 75, 100, 200, 300];
